import {observer} from 'mobx-react';
import Card from '../edit-page/Card';
import Button from '../common/Button';
import renderField from '../edit-page/fields/FieldExtensions';
import ProjectStore from '../../store/projectStore'
import ChooseCustomerModal from './ChooseCustomerModal'
// import { refStructEnhancer } from 'mobx/lib/internal';

const ProjectCustomer = observer(
    class ProjectCustomer extends React.Component {


        // renderField = (field, isEditable) => {
        //     return renderField(field, isEditable, '', () => ProjectStore.setDirty(true));
        // }

        state = {
            editable: []
        }

        onButtonEditClick = field => {
            var newEditable = _.xor(this.state.editable, [field.slug])
            ProjectStore.customerDuringEdit = newEditable.length > 0;
            this.setState({
                editable: newEditable
            })
        }


        renderField = (field, possibleToEdit) => {
            return renderField(field, this.state.editable.includes(field.slug), possibleToEdit, this.onButtonEditClick, '', () => ProjectStore.setDirty(true));
        }


        customerClick() {

            ProjectStore.setChooseCustomerModalVisible(true);

        }

        renderCustomButtons(isEditable) {
            if (!isEditable || !this.props.canAddExistingCustomer)
                return (<React.Fragment></React.Fragment>)
            return (

                <Button size={Button.Size.Small} theme={Button.Theme.BorderOnly} onClick={this.customerClick}>
                    {__('Choose existing customer')}
                </Button>

            )
        }


        render() {
            return (
                // <Card helpInfo={this.props.helpInfo} editableMode={this.props.canEdit} editable={isEditable} customButtons={()=>this.renderCustomButtons(isEditable)} onEditButtonClick={() => ProjectStore.customerDuringEdit = !isEditable} label="End-customer">
                <Card helpInfo={this.props.helpInfo} editableMode={this.props.canEdit} label="End-customer"
                      customButtons={() => this.renderCustomButtons(this.props.canEdit)}>

                    <div className="row row-no-outer-gutter">
                        <div className="column-6 column-xs-12">
                            {this.renderField(ProjectStore.formModel.generalInformation.customerFullName, this.props.canEdit)}
                            {this.renderField(ProjectStore.formModel.generalInformation.customerCompany, this.props.canEdit)}
                        </div>
                        <div className="column-6 column-xs-12">
                            {this.renderField(ProjectStore.formModel.generalInformation.customerAddress, this.props.canEdit)}
                            {this.renderField(ProjectStore.formModel.generalInformation.customerCountry, this.props.canEdit)}
                        </div>
                    </div>
                    {this.props.canAddExistingCustomer && <ChooseCustomerModal twsCustomer={this.props.twsCustomer}/>}
                </Card>
            );
        }


    })


export default ProjectCustomer;
    
